export default "__VITE_ASSET__C9kgv4dK__"